import type { SvgIconComponent } from "@mui/icons-material";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { EdiphiDatasourceType } from "../../context/DatasourceContext";

export interface DatasourceMeta {
  label: string;
  icon?: SvgIconComponent;
  logo?: string;
}

export const EDIPHI_DATASOURCE_META: Record<EdiphiDatasourceType, DatasourceMeta> = {
  estimate: { label: "Estimate", icon: CalculateOutlinedIcon },
  gcgr: { label: "GCGR", icon: HandymanOutlinedIcon },
  contracting: { label: "Contracting", icon: GavelOutlinedIcon },
  "cost-model": { label: "Cost Model", icon: FactCheckOutlinedIcon },
};

export const EDIPHI_DATASOURCE_ORDER: EdiphiDatasourceType[] = ["estimate", "gcgr", "contracting", "cost-model"];
